// SORT_PREFIX needs to be kept consistent with what prefetcher uses
// remove with ff cleanup `clean_local_storage_sorting`
export const SORT_PREFIX = 'QUEUE_ORDER_BY_';
